export default function ServerMessages({serverMessages}) {

	let messages = null;
	if (serverMessages.length > 0) {
		messages = <div>{Array.isArray(serverMessages) ? serverMessages.map((e, i) => <span key={'error' + i}>{e}</span> ) : serverMessages}</div> 
	}

	return messages; 
}